import { IExperiment } from '../../api/experiments';

export function isNpsEnabled(experiments: IExperiment[]): boolean {
  const experiment = experiments.find(({ name }) => name === 'nps');

  return !!(experiment && experiment.abGroup === 1);
}
